import NavigationCarousel from 'components/Content/NavigationCarousel/NavigationCarousel';

export default NavigationCarousel;
